<template>
  <v-app>
    <v-form ref="formQAMapping" v-model="formQAMapping" lazy-validation>
      <v-container fluid>
        <v-row no-gutters class="header d-flex mt-4 mb-1">
          <p class="titlet">Mapping QA - Regional</p>
          <span class="titlet"></span>
          <p v-if="isEdit" class="subTitle">Edit</p>
          <p v-else class="subTitle">Tambah Mapping QA - Regional</p>
        </v-row>
        <v-col cols="12" md="18">
          <div class="top">
            <v-card cols="12">
              <v-card-text>
                <v-row>
                  <v-col md="12">
                    <v-row class="verifStat ml-0">
                      <p class="label-text-field ml-0">NIK</p>
                      <span class="ml-2 mt-1"> Wajib </span>
                    </v-row>
                    <v-dialog v-model="dialogKaryawan" max-width="800px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="inputNik"
                          outlined
                          dense
                          :class="isEdit ? 'dl mb-0' : 'rp mb-0'"
                          hide-details="auto"
                          placeholder="Masukan Nomor Induk Karyawan"
                          :rules="[
                            (v) => !!v || 'Nomor Induk Karyawan harus di isi',
                          ]"
                          v-if="isEdit"
                          readonly
                        >
                        </v-text-field>

                        <v-text-field
                          v-model="inputNik"
                          v-bind="attrs"
                          v-on="on"
                          outlined
                          dense
                          v-else
                          readonly
                          :class="isEdit ? 'dl mb-0' : 'rp mb-0'"
                          hide-details="auto"
                          placeholder="Masukan Nomor Induk Karyawan"
                          :rules="[
                            (v) => !!v || 'Nomor Induk Karyawan harus di isi',
                          ]"
                        >
                        </v-text-field>
                      </template>
                      <v-card>
                        <v-card-text>
                          <v-icon
                            class="icon"
                            style="float: right; margin-top: 12px; cursor: pointer;"
                            @click="closeDialog()"
                            >mdi-close
                          </v-icon>
                        </v-card-text>
                        <v-card-title class="black--text">
                          Karyawan
                        </v-card-title>
                        <v-card-text class="mt-5">
                          <v-row>
                            <v-col class="search-wrapper">
                              <v-text-field
                                label=""
                                class="search-input mb-0"
                                hide-details="auto"
                                v-model="searchValueKaryawan"
                                dense
                                outlined
                              ></v-text-field>
                              <v-btn
                                @click="loadEmployee()"
                                class="search-btn elevation-0 text-capitalize"
                                color="primary"
                              >
                                <span class="white--text">Cari</span>
                              </v-btn>
                            </v-col>
                            
                          </v-row>
                          <v-data-table
                            class="mt-5 mb-5"
                            :headers="headersKaryawan"
                            :items="employeeData"
                            :items-per-page="5"
                            :server-items-length="totalData"
                            :header-props="{ sortIcon: null }"
                            @update:options="updateTableOptions"
                            disable-sort
                          >
                            <template v-slot:item="data">
                              <tr>
                                <td align="center">
                                  {{ data.item.nik }}
                                </td>
                                <td align="center">
                                  {{ data.item.name }}
                                </td>
                                <td align="center">
                                  <v-btn
                                    small
                                    text
                                    class="text-capitalize black--text px-0"
                                    @click="pilihKaryawan(data.item)"
                                  >
                                    <span class="orange--text">Pilih</span>
                                  </v-btn>
                                </td>
                              </tr>
                            </template>
                          </v-data-table>
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                  </v-col>
                  <v-col md="12">
                    <v-row class="verifStat ml-0">
                      <p class="label-text-field ml-0">Nama</p>
                      <span class="ml-2 mt-1"> Wajib </span>
                    </v-row>
                    <v-text-field
                      v-model="inputFullName"
                      :class="isEdit ? 'dl mb-0' : 'rp mb-0'"
                      hide-details="auto"
                      outlined
                      dense
                      placeholder="Masukan nama lengkap"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col md="12">
                    <v-row class="verifStat ml-0">
                      <p class="label-text-field ml-0">DH/Region</p>
                      <span class="ml-2 mt-1"> Wajib </span>
                    </v-row>
                    <v-select
                      :items="regionList"
                      item-text="region"
                      item-value="region"
                      label=""
                      :class="isEdit ? 'dl mb-0' : 'rp mb-0'"
                      hide-details="auto"
                      v-model="inputRegion"
                      outlined
                      dense
                      clearable
                      placeholder="Pilih DH/Region"
                      :rules="[(v) => !!v || 'DH/Region tidak boleh kosong']"
                      multiple
                      chips
                    ></v-select>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </div>
          <v-row>
            <v-col class="text-right">
              <v-btn
                x-large
                depressed
                class="delegasi ml-8"
                color="primary"
                @click="handleSave()"
                ><span class="white--text">Save</span></v-btn
              >
              
              <v-btn :to="`/qa-mapping`" x-large depressed outlined class="back"
                ><span class="primary--text">Cancel</span></v-btn
              >
            </v-col>
          </v-row>
        </v-col>
      </v-container>
    </v-form>
  </v-app>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      page: 1,
      itemsPerPage: 5,
      totalData: null,
      dialogKaryawan: false,
      mappingId: null,
      inputNik: null,
      inputFullName: null,
      inputRegion: [],
      employeeData: [],
      regionList: [],
      headersKaryawan: [
        {
          text: "NIK",
          align: "center",
          width: "86px",
        },
        {
          text: "Nama",
          align: "center",
          width: "90px",
        },
        {
          text: "Tindakan",
          align: "center",
          width: "62px",
        },
      ],
    };
  },

  async mounted() {
    this.loadData();
    this.loadRegion();
  },

  created() {
    this.requiredFeature('QA_MAPPING')
  },

  methods: {
    ...mapActions([
      "changeTitleApp",
      "getInquiryPic",
      "getListRegion",
      "saveQAMapping",
      "loadQAMapping",
    ]),

    closeDialog() {
      this.dialogKaryawan = false
      this.searchValueKaryawan = ''
      this.loadEmployee();
    },

    loadData() {
      if (this.isEdit) {
        this.loadQAMapping({
          id: this.idMapping
        }).then((response) => {
          const formData = response.data.data;

          this.mappingId = formData.mappingId;
          this.inputNik = formData.karyawanNik;
          this.inputFullName = formData.karyawanName;
          this.inputRegion = formData.region.split(',');
        }).catch((err) => {
          this.$helpers.handleError(err);
        });
      }
    },

    handleSave() {
      this.saveQAMapping({
        mappingId: this.mappingId,
        nik: this.inputNik,
        region: this.inputRegion,
        isEdit: this.isEdit,
      }).then((response) => {
        this.$router.push(`/qa-mapping`);
        this.$helpers.handleSuccess(response);
      }).catch((err) => {
        this.$helpers.handleError(err);
      });
    },

    loadEmployee() {
      this.getInquiryPic({
        searchValue: this.searchValueKaryawan,
        role: "QA_LEAD",
        pageNumber: this.page - 1,
        pageSize: this.itemsPerPage
      }).then((response) => {
        this.totalData = response.data.countData;
        this.employeeData = response.data.data;

        console.log("this.totalData", this.totalData);
      }).catch((err) => {
        this.$helpers.handleError(err);
      });
    },

    updateTableOptions(options) {
      this.page = options.page
      this.itemsPerPage = options.itemsPerPage

      this.loadEmployee();
    },

    pilihKaryawan(item) {
      this.dialogKaryawan = false;

      this.inputNik = item.nik;
      this.inputFullName = item.name;
    },

    async loadRegion() {
      try {
        const response = await this.getListRegion();
        
        this.regionList = response.data.data;
      }
      catch (err) {
        this.$helpers.handleError(err);
      }
    },
  },

  computed: {
    idMapping: function () {
      return this.$route.params.id;
    },
    mode() {
      return this.$route.params.mode;
    },
    isEdit: function () {
      return this.mode === "edit";
    },
  },
};
</script>

<style src="./QAMapping.scss" lang="scss" />